

import { register } from 'register-service-worker'
import { notifyUpdateAvailable } from '@/shared/app-update/useAppUpdate'

if (import.meta.env.PROD) {
    register(`${import.meta.env.BASE_URL}service-worker.js`, {
        registered(registration) {
            // The browser only re-checks service-worker.js on navigations, so a
            // long-lived tab would not learn about a deploy until the next reload.
            // Re-check hourly and whenever the tab regains visibility; if a new
            // worker is found, updated() below fires and shows the update banner.
            const checkForUpdates = () => registration.update().catch(() => {})

            setInterval(checkForUpdates, 60 * 60 * 1000)
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    checkForUpdates()
                }
            })
        },
        updated() {
            notifyUpdateAvailable()
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        },
    })
}
